import { getAccessToken, triggerReauth } from './auth.js';

async function attachAuthHeader(headers: Headers, forceRefresh = false): Promise<void> {
  const token = await getAccessToken(forceRefresh);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  } else {
    headers.delete('Authorization');
  }
}

export async function apiFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers || {});

  try {
    await attachAuthHeader(headers);
  } catch {
    await triggerReauth();
    throw new Error('Authentication required');
  }

  const send = () => fetch(input, { ...init, headers });
  let response = await send();

  if (response.status !== 401) {
    return response;
  }

  try {
    await attachAuthHeader(headers, true);
  } catch {
    await triggerReauth();
    throw new Error('Authentication required');
  }

  response = await send();

  if (response.status === 401) {
    await triggerReauth();
    throw new Error('Authentication required');
  }

  return response;
}
